window.renderPhotoFramer = function(rootElement, options) {
	rootElement.style.position = "relative";
	rootElement.style.width = options.width || options.mask_width;
	rootElement.style.height = options.height || options.mask_height;

	var fileUpload = document.createElement("input");
	fileUpload.type = "file";
	fileUpload.accept = "image/*";
	fileUpload.capture = "user";
	fileUpload.style.display = "none";
	rootElement.append(fileUpload);
	
	var uploadButtons = document.getElementsByClassName("framing_upload_button");
	if (uploadButtons.length === 0) {
		uploadButton = document.createElement("a");
		uploadButton.href = "javascript:void(0)";
		uploadButton.className = "framing_upload_button";
		uploadButton.style.display = "block";
		uploadButton.style.position = "absolute";
		uploadButton.style.top = options.upload_y || 0;
		uploadButton.style.height = options.upload_height || "100%";
		uploadButton.style.width = options.upload_width || "100%";
		uploadButton.style.left = options.upload_x || 0;
		if (options.upload_image) {
			uploadButton.style.backgroundImage = "url('"+options.upload_image+"')";
			uploadButton.style.backgroundRepeat = "no-repeat";
			uploadButton.style.backgroundSize = "cover";
		}
		if (options.upload_html) uploadButton.innerHTML = options.upload_html;
		rootElement.append(uploadButton);
		uploadButtons = [uploadButton];
	}
	for (var uploadButton of uploadButtons) {
		uploadButton.onclick = fileUpload.click.bind(fileUpload);
	}
	
	var canvas = document.createElement("canvas");
	canvas.style.width = "100%";
	canvas.style.height = "100%";
	canvas.width = options.mask_width;
	canvas.height = options.mask_height;
	canvas.style.display = "block";
	rootElement.append(canvas);

	var downloadLinks = document.getElementsByClassName("framing_download_button");
	if (downloadLinks.length === 0) {
		downloadLink = document.createElement("a");
		downloadLink.className = "framing_download_button";
		downloadLink.style.position = "absolute";
		downloadLink.style.top = options.download_y || 0;
		downloadLink.style.height = options.download_height || "100%";
		downloadLink.style.width = options.download_width || "100%";
		downloadLink.style.left = options.download_x || 0;
		if (options.download_image) {
			downloadLink.style.backgroundImage = "url('"+options.download_image+"')";
			downloadLink.style.backgroundRepeat = "no-repeat";
			downloadLink.style.backgroundSize = "cover";
		}
		if (options.download_html) downloadLink.innerHTML = options.download_html;
		rootElement.append(downloadLink);
		downloadLinks = [downloadLink];
	}
	for (var downloadLink of downloadLinks) {
		downloadLink.style.display = "none";
		downloadLink.download = options.download_filename || "photo";
		downloadLink.href = "javascript:void(0)";
	}
	
	var ctx = canvas.getContext("2d");
	
	var maskImg = new Image();
	maskImg.src = options.mask_url;
	maskImg.addEventListener("load", () => {
		ctx.clearRect(0, 0, options.mask_width, options.mask_height);
		ctx.drawImage(maskImg, 0, 0, options.mask_width, options.mask_height);
	});
	function readImage() {
	  if (!this.files || !this.files[0]) return;
	  
	  var fileReader = new FileReader();
	  fileReader.addEventListener("load", (evt) => {
		var img = new Image();
		img.addEventListener("load", () => {
			console.log(img.width, img.height, img);
			var rectRatio = options.mask_width / options.mask_height;
			var imgRatio = img.width / img.height;
			var offsetx;
			var offsety;
			var imgWidth;
			var imgHeight;
			if (imgRatio >= rectRatio) {
				imgHeight = options.image_height;
				offsety = options.offset_y;
				imgWidth = imgRatio * imgHeight;
				offsetx = options.offset_x - (imgWidth - options.image_width)/2;
			} else {
				imgWidth = options.image_width;
				offsetx = options.offset_x;
				imgHeight = imgWidth / imgRatio;
				offsety = options.offset_y - (imgHeight - options.image_height)/2;
			}
			ctx.clearRect(0, 0, options.mask_width, options.mask_height);
			ctx.drawImage(img, offsetx, offsety, imgWidth, imgHeight);
			ctx.drawImage(maskImg, 0, 0, options.mask_width, options.mask_height);
			for (var downloadLink of downloadLinks) {
				downloadLink.href = canvas.toDataURL('image/jpeg', 0.9);
				downloadLink.style.display = "block";
				rootElement.className = (rootElement.className || "") + " framed_photo_ready";
			}
			for (var uploadButton of uploadButtons) {
				uploadButton.style.display = "none";
			}
		});
		img.src = evt.target.result;
	  });
	  fileReader.readAsDataURL(this.files[0]);
	}

	fileUpload.addEventListener("change", readImage);
}
if (window.photoFramingOptions) {
	window.renderPhotoFramer(window.photoFramingOptions.rootElement || document.getElementById("photo_framing"), window.photoFramingOptions);
}
